import {Component, computed, inject} from '@angular/core';
import {Card} from '../../../../shared/components/card/card';
import {CheckboxComponent} from '../../../../shared/components/checkbox/checkbox.component';
import {CurrencyPipe} from '@angular/common';
import {CompareStore} from '../../compare.store';

@Component({
  selector: 'app-compare-options',
  standalone: true,
  imports: [
    Card,
    CheckboxComponent,
    CurrencyPipe,
  ],
  templateUrl: './compare-options.component.html',
  styleUrl: './compare-options.component.css',
})
export class CompareOptionsComponent {
  protected compareStore = inject(CompareStore);

  addons = computed(() => this.compareStore.unified_addons().addons.filter(({optional}) => optional));
}
